import Achievement from '../classes/achievement';
import Shops from '../api/shops';

let _achievements = [
    new Achievement({
        id:          'a0',
        name:        '1 of everything',
        type:        'shopAmount',
        branches:    1,
        bonusType:   'increaseEarnings',
        bonusFactor: 2,
        shopID:      'all'
    }),
    new Achievement({
        id:          'a1',
        name:        '100 of everything',
        type:        'shopAmount',
        branches:    100,
        bonusType:   'increaseEarnings',
        bonusFactor: 2,
        shopID:      'all'
    }),
    new Achievement({
        id:          'a2',
        name:        '500 of everything',
        type:        'shopAmount',
        branches:    500,
        bonusType:   'increaseEarnings',
        bonusFactor: 2,
        shopID:      'all'
    }),
    new Achievement({
        id:          'a3',
        name:        '1000 of everything',
        type:        'shopAmount',
        branches:    1000,
        bonusType:   'increaseEarnings',
        bonusFactor: 2,
        shopID:      'all'
    }),
    new Achievement({
        id:          'a4',
        name:        '2222 of everything',
        type:        'shopAmount',
        branches:    2222,
        bonusType:   'increaseEarnings',
        bonusFactor: 2,
        shopID:      'all'
    }),
    new Achievement({
        id:          'a5',
        name:        '10000 of everything',
        type:        'shopAmount',
        branches:    10000,
        bonusType:   'increaseEarnings',
        bonusFactor: 2,
        shopID:      'all'
    }),
    new Achievement({
        id:          'a10',
        name:        'Millionaire',
        type:        'balance',
        balance:     1E06,
        bonusType:   'increaseEarnings',
        bonusFactor: 2,
        shopID:      'all'
    }),
    new Achievement({
        id:          'a11',
        name:        'Sextillionaire',
        type:        'balance',
        balance:     1E21,
        bonusType:   'increaseEarnings',
        bonusFactor: 2,
        shopID:      'all'
    }),
    new Achievement({
        id:          'a12',
        name:        'Sexdecillionaire',
        type:        'balance',
        balance:     1E51,
        bonusType:   'increaseEarnings',
        bonusFactor: 2,
        shopID:      'all'
    }),
    new Achievement({
        id:          'a13',
        name:        'Googolnaire',
        type:        'balance',
        balance:     1E100,
        bonusType:   'increaseEarnings',
        bonusFactor: 2,
        shopID:      'all'
    })
];
_achievements.forEach(achievement => {
    if (achievement.type === 'balance') {
        achievement.faClass = 'fa-money';
        achievement.iconOverlay = achievement.balance;
    } else if (achievement.type === 'shopAmount') {
        achievement.faClass = 'fa-industry';
        achievement.iconOverlay = achievement.branches;
    }
});

const addDynamic = shops => {
    shops.forEach((shop, i) => {
        let upgradeLen = shop.autoUpgrades.length;
        for (let j = 0; j < upgradeLen; ++j) {
            _achievements.push(new Achievement({
                amount:      shop.autoUpgrades[j].amount,
                isAchieved:  false,
                id:          `shop-${i}-ug${j}`,
                shopID:      shop.id,
                type:        'autoUpgrade',
                name:        `${shop.autoUpgrades[j]} x ${shop.name}`,
                bonusType:   shop.autoUpgrades[j].type,
                bonusFactor: shop.autoUpgrades[j].factor,
                icon:        shop.getIcon(),
                faClass:     shop.faClass,
                iconOverlay: shop.autoUpgrades[j].amount,
                branches:    shop.autoUpgrades[j].amount,
                shopName:    shop.name
            }));
        }
    });
};
Shops.getShops(addDynamic);

export default {
    getAchievements(cb) {
        return cb(_achievements);
    }
};
